import { create } from "zustand";

export interface BodyRemovalItem {
  id: string;
  caseId: string;
  caseNumber: string;
  bodyRemovalNumber: string;
  bodyRemovalStatus: string;
  assignedTo?: string;
  assigned_to?: string;
  isManual: boolean;
  driverId?: string;
  driverUserId?: string;
  driverEmail?: string;
  driverName?: string;
  claimId: string;
  claimant: {
    title: string;
    first_name: string;
    last_name: string;
    identification_type: string;
    identification_number: string;
    contact_number: string;
    email: string;
  };

  deceased: {
    title?: string;
    initials?: string;
    first_name: string;
    last_name: string;
    relationship?: string;
    date_of_birth?: string;
    date_of_death: string;
    cause_of_death?: string;
    identification_number: string;
    identification_type?: string;
  };

  allocationDetails: {
    message: string;
    bodyRemovalNumber: string;
    caseNumber: string;
    status: string;
    driverId?: string;
    driverUserId?: string;
    driverEmail?: string;
    driverName: string;
    driverPhone: string;
    vehicleNumber: string;
    vehicleType: string;
    expectedPickupDate: string;
    expectedPickupTime: string;
    contactPersonAtLocation: string;
    contactNumber: string;
    assignedBy: string;
  };

  bodyRemoval?: any;

  documentResponseDtoList: {
    document_id: string;
    document_type: string;
    file_url: string;
    file_name: string;
  }[];

  createdAt: string;
  updatedAt: string;
}

interface BodyRemovalState {
  bodyRemovals: BodyRemovalItem[];
  totalElements: number;
  statusCounts: Record<string, number>;
  selectedBodyRemoval: BodyRemovalItem | null;

  setBodyRemovals: (data: any) => void;
  setSelectedBodyRemoval: (item: BodyRemovalItem) => void;
  clearSelectedBodyRemoval: () => void;
}

export const useBodyRemovalsStore = create<BodyRemovalState>((set) => ({
  bodyRemovals: [],
  totalElements: 0,
  statusCounts: {},
  selectedBodyRemoval: null,

  setBodyRemovals: (data) =>
    set({
      bodyRemovals: data?.bodyRemovals || [],
      totalElements: data?.totalCount || 0,
      statusCounts: data?.statusCounts || {},
    }),

  setSelectedBodyRemoval: (item) =>
    set({
      selectedBodyRemoval: item,
    }),

  clearSelectedBodyRemoval: () =>
    set({
      selectedBodyRemoval: null,
    }),
}));
